module.exports = "<app-header icon=\"menu\" title=\"Forbidden\"></app-header>\n<p>Navigate home <a routerLink=\"/\">Home</a> </p>\n"